var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "mt-2": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs10: "", "ml-4": "", "pl-2": "" } },
            [
              _c("h1", { staticClass: "primary--text" }, [
                _vm._v(_vm._s(_vm.meetingName))
              ]),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs2: "" } },
                [
                  _c("v-card", {
                    attrs: {
                      flat: "",
                      color: "red",
                      height: "1px",
                      width: "100%"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.$route.meta["bm_archive"] ||
          _vm.$route.meta["bm_delete"] ||
          _vm.$route.meta["bm_edit"]
            ? _c(
                "v-flex",
                {
                  staticClass: "actions-menu__wrapper",
                  attrs: { "text-xs-right": "" }
                },
                [
                  _c(
                    "v-menu",
                    {
                      staticClass: "pr-2 actions-menu__menu",
                      attrs: {
                        "offset-y": "",
                        bottom: "",
                        transition: "slide-x-transition",
                        "close-on-content-click": false,
                        "content-class": "menu-content__block"
                      },
                      model: {
                        value: _vm.dtActionOpen,
                        callback: function($$v) {
                          _vm.dtActionOpen = $$v
                        },
                        expression: "dtActionOpen"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            slot: "activator",
                            fab: "",
                            dark: "",
                            small: "",
                            color: _vm.dtActionOpen ? "red" : "primary"
                          },
                          slot: "activator"
                        },
                        [
                          _c("v-icon", { attrs: { dark: "" } }, [
                            _vm._v("more_horiz")
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list",
                        { staticClass: "actions-menu__list" },
                        [
                          _c(
                            "v-list-tile",
                            {
                              attrs: {
                                disabled:
                                  !_vm.$route.meta["bm_edit"] ||
                                  _vm.isGenerateReport
                              },
                              on: { click: _vm.handleEditMeeting }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color:
                                          _vm.$route.meta["bm_edit"] &&
                                          !_vm.isGenerateReport
                                            ? "primary"
                                            : "greyLight"
                                      }
                                    },
                                    [_vm._v("edit")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                {
                                  class: {
                                    disabled:
                                      !_vm.$route.meta["bm_edit"] ||
                                      _vm.isGenerateReport
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.lblSetting
                                            .bmMeetingUpdateModalBtnTitle
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            attrs: { color: "red", inset: "" }
                          }),
                          _vm._v(" "),
                          !_vm.isGenerateReport
                            ? _c(
                                "v-list-tile",
                                {
                                  attrs: {
                                    disabled: !_vm.$route.meta["bm_edit"]
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.openBaseModal(
                                        _vm.ActionModal.GenerateReport
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-avatar",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            color: _vm.$route.meta["bm_edit"]
                                              ? "primary"
                                              : "greyLight"
                                          }
                                        },
                                        [_vm._v("assignment_turned_in")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-content",
                                    {
                                      class: {
                                        disabled: !_vm.$route.meta["bm_edit"]
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              _vm.lblSetting.bmGenerateReport
                                            )
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isGenerateReport
                            ? _c("v-divider", {
                                attrs: { color: "red", inset: "" }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            {
                              attrs: {
                                disabled: !_vm.$route.meta["bm_delete"]
                              },
                              on: { click: _vm.handleDeleteMeeting }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.$route.meta["bm_delete"]
                                          ? "primary"
                                          : "greyLight"
                                      }
                                    },
                                    [_vm._v("delete")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                {
                                  class: {
                                    disabled: !_vm.$route.meta["bm_delete"]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.lblSetting.bmMeetingDeleteBtn
                                        )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-divider", {
                            attrs: { color: "red", inset: "" }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-list-tile",
                            {
                              attrs: {
                                disabled: !_vm.$route.meta["bm_archive"]
                              },
                              on: { click: _vm.handleArchiveMeeting }
                            },
                            [
                              _c(
                                "v-list-tile-avatar",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        color: _vm.$route.meta["bm_archive"]
                                          ? "primary"
                                          : "greyLight"
                                      }
                                    },
                                    [_vm._v("archive")]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-tile-content",
                                {
                                  class: {
                                    disabled: !_vm.$route.meta["bm_archive"]
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.bmMeeting.data.is_archived
                                          ? _vm.$t(
                                              _vm.lblSetting
                                                .bmMeetingUnarchiveBtn
                                            )
                                          : _vm.$t(
                                              _vm.lblSetting.bmMeetingArchiveBtn
                                            )
                                      ) +
                                      "\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.coMeetingDetailLoader && _vm.bmMeeting.data.media_pdf
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "ml-4": "", "pl-2": "" } },
            [
              _c(
                "v-card",
                { staticClass: "px-3 md12", attrs: { width: "95%" } },
                [
                  _c(
                    "v-list",
                    { attrs: { "three-line": "" } },
                    [
                      _c(
                        "v-list-tile",
                        [
                          _c(
                            "v-layout",
                            {
                              staticStyle: { cursor: "pointer" },
                              attrs: { column: "" },
                              on: {
                                click: function(e) {
                                  return _vm.handleViewDocument(
                                    e,
                                    _vm.bmMeeting.data.media_pdf.link
                                  )
                                }
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                [
                                  _c(
                                    "v-layout",
                                    {
                                      attrs: { row: "", nowrap: "", "mb-2": "" }
                                    },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "ml-3 mt-2",
                                          attrs: { color: "primary" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "headline white--text",
                                              staticStyle: {
                                                "font-size": "15px !important"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.attachmentType(
                                                      _vm.bmMeeting.data
                                                        .media_pdf.link
                                                    )
                                                  ) +
                                                  "\n                  "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ml-4",
                                          staticStyle: { width: "80%" }
                                        },
                                        [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  _vm.lblSetting.bmReportMeeting
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          !_vm.dtIsLoading
                                            ? _c("p", {
                                                staticStyle: {
                                                  margin: "0",
                                                  padding: "0",
                                                  color: "#999",
                                                  "font-size": "15px"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      _vm.lblSetting
                                                        .bmDocumentText,
                                                      {
                                                        who:
                                                          _vm.bmMeeting.data
                                                            .media_pdf
                                                            .creator_name,
                                                        when: _vm.getDateDuration(
                                                          _vm.bmMeeting.data
                                                            .media_pdf.createdAt
                                                        )
                                                      }
                                                    )
                                                  )
                                                }
                                              })
                                            : _vm._e()
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "", "mx-4": "", "pl-2": "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c("v-hover", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var hover = ref.hover
                      return _c(
                        "div",
                        {},
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                "align-center": "",
                                "mt-4": "",
                                "mr-4": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs10: "" } },
                                [
                                  _c("h1", { staticClass: "primary--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(_vm.lblSetting.bmMeetingPlan)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("v-card", {
                                        attrs: {
                                          flat: "",
                                          color: "red",
                                          height: "1px",
                                          width: "100%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { height: "52px" },
                                  attrs: { xs2: "", "text-xs-right": "" }
                                },
                                [
                                  _c(
                                    "v-fade-transition",
                                    [
                                      hover &&
                                      !_vm.isGenerateReport &&
                                      _vm.$route.meta["bm_edit"]
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "mr-0",
                                              attrs: {
                                                color: "primary",
                                                fab: "",
                                                dark: "",
                                                small: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.openBaseModal(
                                                    _vm.ActionModal.PlanAdd
                                                  )
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("add")])],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass: "px-3 md12 mr-4",
                                  attrs: { width: "100%" }
                                },
                                [
                                  _c(
                                    "v-list",
                                    { attrs: { "three-line": "" } },
                                    _vm._l(_vm.bmMeetingPlan, function(
                                      item,
                                      index
                                    ) {
                                      return _c(
                                        "v-list-tile",
                                        { key: index },
                                        [
                                          _c(
                                            "v-layout",
                                            {
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              attrs: { column: "" },
                                              on: {
                                                click: function(e) {
                                                  return _vm.handleViewDocument(
                                                    e,
                                                    item.media.link
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-flex",
                                                [
                                                  _c(
                                                    "v-layout",
                                                    {
                                                      attrs: {
                                                        row: "",
                                                        nowrap: "",
                                                        "mb-2": ""
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-avatar",
                                                        {
                                                          staticClass:
                                                            "ml-3 mt-2",
                                                          attrs: {
                                                            color: "primary"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "headline white--text",
                                                              staticStyle: {
                                                                "font-size":
                                                                  "15px !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                            " +
                                                                  _vm._s(
                                                                    _vm.attachmentType(
                                                                      item.media
                                                                        .name
                                                                    )
                                                                  ) +
                                                                  "\n                          "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "ml-4" },
                                                        [
                                                          !_vm.coMeetingPlanLoader
                                                            ? _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.media
                                                                      .name
                                                                  )
                                                                )
                                                              ])
                                                            : _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "mt-3 mb-2",
                                                                  staticStyle: {
                                                                    width:
                                                                      "100%"
                                                                  }
                                                                },
                                                                [
                                                                  _c(
                                                                    "block-infos-loader",
                                                                    {
                                                                      attrs: {
                                                                        height: 10,
                                                                        width: 130
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                          _vm._v(" "),
                                                          !_vm.coMeetingPlanLoader
                                                            ? _c("br")
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.coMeetingPlanLoader
                                                            ? _c("p", {
                                                                staticStyle: {
                                                                  margin: "0",
                                                                  padding: "0",
                                                                  color: "#999",
                                                                  "font-size":
                                                                    "15px"
                                                                },
                                                                domProps: {
                                                                  innerHTML: _vm._s(
                                                                    _vm.$t(
                                                                      _vm
                                                                        .lblSetting
                                                                        .blockDocumentText,
                                                                      {
                                                                        who:
                                                                          item.creator_name,
                                                                        when: _vm.getDateDuration(
                                                                          item.createdAt
                                                                        )
                                                                      }
                                                                    )
                                                                  )
                                                                }
                                                              })
                                                            : _c(
                                                                "block-infos-loader",
                                                                {
                                                                  attrs: {
                                                                    height: 10,
                                                                    width: 80
                                                                  }
                                                                }
                                                              )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("hr", {
                                                attrs: {
                                                  size: "1px",
                                                  width: "100%",
                                                  color: "#DDD"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          hover &&
                                          !_vm.isGenerateReport &&
                                          _vm.$route.meta["bm_edit"]
                                            ? _c(
                                                "v-list-tile-action",
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        ripple: ""
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.openDeletePlan(
                                                            item
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            color: "primary"
                                                          }
                                                        },
                                                        [_vm._v("close")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.bmMeetingPlan.length === 0
                                    ? _c(
                                        "v-flex",
                                        {
                                          attrs: {
                                            "mb-4": "",
                                            "mt-2": "",
                                            "text-xs-center": ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(_vm.lblSetting.bmNoPlan)
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs6: "" } },
            [
              _c("v-hover", {
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var hover = ref.hover
                      return _c(
                        "div",
                        {},
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                "align-center": "",
                                "mt-4": "",
                                "mr-4": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs10: "" } },
                                [
                                  _c("h1", { staticClass: "primary--text" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          _vm.lblSetting.bmMeetingParticipant
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs3: "" } },
                                    [
                                      _c("v-card", {
                                        attrs: {
                                          flat: "",
                                          color: "red",
                                          height: "1px",
                                          width: "100%"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { height: "52px" },
                                  attrs: { xs2: "", "text-xs-right": "" }
                                },
                                [
                                  _c(
                                    "v-fade-transition",
                                    [
                                      hover &&
                                      !_vm.isGenerateReport &&
                                      _vm.$route.meta["bm_edit"]
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "mr-0",
                                              attrs: {
                                                color: "primary",
                                                fab: "",
                                                dark: "",
                                                small: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.openBaseModal(
                                                    _vm.ActionModal.MemberAdd
                                                  )
                                                }
                                              }
                                            },
                                            [_c("v-icon", [_vm._v("add")])],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-carousel",
                                {
                                  staticClass: "mr-4 white--background",
                                  attrs: {
                                    height: "250",
                                    width: "100%",
                                    cycle: false,
                                    light: true,
                                    "hide-controls":
                                      _vm.participansContactIndexer.length < 2
                                  }
                                },
                                _vm._l(_vm.participansContactIndexer, function(
                                  index,
                                  i
                                ) {
                                  return _c(
                                    "v-carousel-item",
                                    {
                                      key: typeof index === "object" ? i : index
                                    },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            row: "",
                                            wrap: "",
                                            "justify-center": "",
                                            "mt-4": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              class: {
                                                "xs4 pt-5 mt-4":
                                                  _vm.coMeetingDetailLoader,
                                                xs5: !_vm.coMeetingDetailLoader
                                              },
                                              style: _vm.$route.meta["bm_edit"]
                                                ? "cursor: pointer;"
                                                : "",
                                              attrs: { "ml-2": "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.$route.meta["bm_edit"]
                                                    ? _vm.openBaseModal(
                                                        _vm.ActionModal
                                                          .MemberUp,
                                                        _vm.participansContact[
                                                          index
                                                        ]
                                                      )
                                                    : ""
                                                }
                                              }
                                            },
                                            [
                                              !_vm.coMeetingDetailLoader
                                                ? _c("user-profile-widget", {
                                                    attrs: {
                                                      user:
                                                        _vm.participansContact[
                                                          index
                                                        ]
                                                    }
                                                  })
                                                : _c("block-infos-loader", {
                                                    attrs: {
                                                      height: 220,
                                                      width: "360"
                                                    }
                                                  })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              class: {
                                                "xs4 pt-5 mt-4":
                                                  _vm.coMeetingDetailLoader,
                                                xs5: !_vm.coMeetingDetailLoader
                                              },
                                              style:
                                                index + 1 ===
                                                _vm.participansContact.length
                                                  ? ""
                                                  : _vm.$route.meta["bm_edit"]
                                                  ? "cursor: pointer;"
                                                  : "",
                                              attrs: { "ml-2": "" },
                                              on: {
                                                click: function($event) {
                                                  _vm.$route.meta["bm_edit"]
                                                    ? _vm.openBaseModal(
                                                        _vm.ActionModal
                                                          .MemberUp,
                                                        _vm.participansContact[
                                                          index + 1
                                                        ]
                                                      )
                                                    : ""
                                                }
                                              }
                                            },
                                            [
                                              _vm.participansContact[index + 1]
                                                ? [
                                                    !_vm.coMeetingDetailLoader
                                                      ? _c(
                                                          "user-profile-widget",
                                                          {
                                                            attrs: {
                                                              user:
                                                                _vm
                                                                  .participansContact[
                                                                  index + 1
                                                                ]
                                                            }
                                                          }
                                                        )
                                                      : _c(
                                                          "block-infos-loader",
                                                          {
                                                            attrs: {
                                                              width: "360"
                                                            }
                                                          }
                                                        )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.coMeetingDetailLoader && _vm.bmMeeting.data.generalComments
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "mx-4": "", "pl-2": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c(
                    "v-layout",
                    {
                      attrs: {
                        row: "",
                        "align-center": "",
                        "mt-4": "",
                        "mr-4": ""
                      }
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs10: "" } },
                        [
                          _c("h1", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(_vm.$t(_vm.lblSetting.bmGlobalInspection))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-card", {
                                attrs: {
                                  flat: "",
                                  color: "red",
                                  height: "1px",
                                  width: "100%"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", {
                        staticStyle: { height: "52px" },
                        attrs: { xs2: "", "text-xs-right": "" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    { staticClass: " px-3 py-2 mr-4" },
                    [
                      _c(
                        "v-list",
                        { staticClass: "pb-0", attrs: { subheader: "" } },
                        [
                          _c("ib-item", {
                            attrs: {
                              ib: _vm.bmMeeting.data.generalComments,
                              comments: _vm.comments,
                              dtIsLoading: _vm.dtIsLoading,
                              disableActions: _vm.isGenerateReport
                            },
                            on: { openBaseModal: _vm.openBaseModal }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.coMeetingDetailLoader && _vm.bmMeeting.data.inspections
        ? _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "mx-4": "", "pl-2": "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "" } },
                [
                  _c("v-hover", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var hover = ref.hover
                          return _c(
                            "div",
                            {},
                            [
                              _c(
                                "v-layout",
                                {
                                  attrs: {
                                    row: "",
                                    "align-center": "",
                                    "mt-4": "",
                                    "mr-4": ""
                                  }
                                },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs10: "" } },
                                    [
                                      _c(
                                        "h1",
                                        { staticClass: "primary--text" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                _vm.lblSetting
                                                  .bmInspectionBundle
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-flex",
                                        { attrs: { xs2: "" } },
                                        [
                                          _c("v-card", {
                                            attrs: {
                                              flat: "",
                                              color: "red",
                                              height: "1px",
                                              width: "100%"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticStyle: { height: "52px" },
                                      attrs: { xs2: "", "text-xs-right": "" }
                                    },
                                    [
                                      _c(
                                        "v-fade-transition",
                                        [
                                          hover &&
                                          !_vm.isGenerateReport &&
                                          _vm.$route.meta["bm_edit"]
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass: "mr-0",
                                                  attrs: {
                                                    color: "primary",
                                                    fab: "",
                                                    dark: "",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      _vm.openBaseModal(
                                                        _vm.ActionModal.IBAdd
                                                      )
                                                    }
                                                  }
                                                },
                                                [_c("v-icon", [_vm._v("add")])],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-card",
                                { staticClass: "px-3 mr-4 py-2" },
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "pb-0",
                                      attrs: { subheader: "" }
                                    },
                                    _vm._l(
                                      _vm.bmMeeting.data.inspections,
                                      function(inspection) {
                                        return _c("ib-item", {
                                          key: inspection.id,
                                          attrs: {
                                            ib: inspection,
                                            comments: _vm.comments,
                                            dtIsLoading: _vm.dtIsLoading,
                                            disableActions: _vm.isGenerateReport
                                          },
                                          on: {
                                            openBaseModal: _vm.openBaseModal,
                                            openDeleteImageComment:
                                              _vm.openDeleteImageComment,
                                            openDeleteIB: _vm.openDeleteIB
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.bmMeeting.data.inspections.length === 0
                                    ? _c(
                                        "v-flex",
                                        { attrs: { "text-xs-center": "" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(_vm.lblSetting.bmNoIB)
                                            ) + "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "base-modal-duplicate",
        {
          attrs: {
            loading: _vm.dtBaseModalLoading,
            "before-close": _vm.handleBeforeModalClose,
            "submit-btn-title": _vm.$t(_vm.modalBtnTitle),
            title: _vm.$t(_vm.modalTitle),
            "hide-default-action": true,
            "action-position": "center",
            icon: "icon-newticket",
            "icon-type": "icon",
            "max-width": "80%",
            isRedTitle: ""
          },
          on: { onRecord: _vm.handleSave, onClose: _vm.handleClose },
          model: {
            value: _vm.dtOpenBaseModal,
            callback: function($$v) {
              _vm.dtOpenBaseModal = $$v
            },
            expression: "dtOpenBaseModal"
          }
        },
        [
          _vm.dtBaseModalAction === _vm.ActionModal.MemberAdd ||
          _vm.dtBaseModalAction === _vm.ActionModal.MemberUp
            ? _c("participant-modal-vertical", {
                attrs: {
                  toUpdate: _vm.dtBaseModalAction === _vm.ActionModal.MemberUp
                }
              })
            : _vm.dtBaseModalAction === _vm.ActionModal.ContractorAdd ||
              _vm.dtBaseModalAction === _vm.ActionModal.ContractorUp
            ? _c("contractor-modal-vertical", {
                attrs: {
                  toUpdate:
                    _vm.dtBaseModalAction === _vm.ActionModal.ContractorUp,
                  sourceContractor: _vm.dtItemSelected
                }
              })
            : _vm.dtBaseModalAction === _vm.ActionModal.IBAdd ||
              _vm.dtBaseModalAction === _vm.ActionModal.IBUp
            ? _c("ib-modal-vertical", {
                attrs: {
                  toUpdate: _vm.dtBaseModalAction === _vm.ActionModal.IBUp
                }
              })
            : _vm.dtBaseModalAction === _vm.ActionModal.CommentAdd ||
              _vm.dtBaseModalAction === _vm.ActionModal.CommentUp
            ? _c("comment-modal-vertical", {
                attrs: {
                  commentSelected: _vm.dtItemSelected,
                  attachments: _vm.dtAttachments,
                  toUpdate: _vm.dtBaseModalAction === _vm.ActionModal.CommentUp
                },
                on: {
                  "update:attachments": function($event) {
                    _vm.dtAttachments = $event
                  }
                }
              })
            : _vm.dtBaseModalAction === _vm.ActionModal.PlanSelect
            ? _c("plan-marker-modal-vertical", {
                attrs: { params: _vm.dtItemSelected, disabled: false }
              })
            : _vm.dtBaseModalAction === _vm.ActionModal.PlanAdd
            ? _c("plan-modal-vertical")
            : _vm.dtBaseModalAction === _vm.ActionModal.GenerateReport
            ? _c(
                "v-layout",
                { attrs: { column: "", "px-3": "" } },
                [
                  _c("h1", { staticClass: "primary--text mt-3 mx-2" }, [
                    _vm._v(
                      _vm._s(_vm.$t(_vm.lblSetting.bmGenerateReportMeeting))
                    )
                  ]),
                  _vm._v(" "),
                  _c("base-control-label-vertical", {
                    staticClass: "my-3",
                    attrs: { label: _vm.lblSetting.bmGenerateReportSignatures }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-flex",
            {
              attrs: { slot: "action-between", shrink: "", "mr-2": "" },
              slot: "action-between"
            },
            [
              _vm.dtShowDeleteBtn
                ? _c("base-modal-submit-btn", {
                    attrs: {
                      title: _vm.$t(_vm.lblSetting.lblDelete),
                      loading: _vm.dtBaseModalLoading,
                      color: "red"
                    },
                    on: { record: _vm.openDeleteItem }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.dtShowDeleteBtn &&
              _vm.dtBaseModalAction === _vm.ActionModal.CommentUp
                ? _c("base-modal-submit-btn", {
                    attrs: {
                      title: _vm.$t(
                        _vm.dtItemSelected.state === "open"
                          ? _vm.lblSetting.bmCommentClose
                          : _vm.lblSetting.bmCommentOpen
                      ),
                      loading: _vm.dtBaseModalLoading,
                      color: "secondary"
                    },
                    on: { record: _vm.openCloseComment }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isOpenDeleteMessage
        ? _c("base-delete-dialog", {
            attrs: {
              "is-loading": _vm.dtIsLoading,
              message: _vm.deleteModalText
            },
            on: { cancel: _vm.handleDeleteCancel, delete: _vm.handleDeleteOK }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.dtErrorModalVisible
        ? _c("base-error-dialog", {
            attrs: { error: _vm.dtError },
            on: { cancel: _vm.handleRemoveError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a8028b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a8028b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/building-monitor/bm-meeting-detail/template.html
// module id = null
// module chunks = 